<template>
  <v-navigation-drawer
    :clipped="clipped"
    app
    persistent
    v-if="leftmenu.enabled"
    v-model="leftmenu.show"
    id="main-left-menu"
  >
    <v-list class="fill-height">
      <v-layout column fill-height justify-space-between>
        <v-sheet>
          <template v-for="(item, i) in leftmenu.items">
            <span :key="i" v-if="!item.base">
              <LeftMenuAction
                :activeRouter="leftmenu.activeRouter"
                :i="i"
                :item="item"
                @changeActiveRouter="changeActiveRouter"
                currentInstance="null"
                v-if="item.router"
              ></LeftMenuAction>
              <v-list-group
                :icon="item.icon || ''"
                :value="inSubs(item)"
                no-action
                v-if="!item.router && !item.base"
              >
                <v-list-tile slot="activator">
                  <v-list-tile-title>{{item.title}}</v-list-tile-title>
                </v-list-tile>
                <template v-for="(subitem, j) in item.subs">
                  <LeftMenuAction
                    :activeRouter="leftmenu.activeRouter"
                    :i="j"
                    :item="subitem"
                    :key="j"
                    @changeActiveRouter="changeActiveRouter"
                  ></LeftMenuAction>
                </template>
              </v-list-group>
              <v-divider class="pt-2 " v-if="item.part"></v-divider>
            </span>
          </template>
        </v-sheet>
        <v-sheet>
          <template v-for="(item, i) in leftmenu.instances.slice().reverse()">
            <span :key="i">
              <v-divider class="pt-2 "></v-divider>
              <LeftMenuAction
                :currentInstance="leftmenu.currentInstance"
                :i="i"
                :item="item"
                @changeActiveRouter="changeCurrentInstance"
                v-if="item.router"
              ></LeftMenuAction>
            </span>
          </template>
        </v-sheet>
      </v-layout>
    </v-list>

  </v-navigation-drawer>
</template>

<script>
  import {mapState} from 'vuex'
  import LeftMenuAction from './LeftMenuAction'

  export default {
    name: 'leftmenu',
    components: {LeftMenuAction},
    data() {
      return {
        clipped: true,
        drawer: true,
        // activeRouter: this.$router.currentRoute.name !== null ? this.$router.currentRoute.name: this.leftmenu.activeRouter,
      }
    },
    computed: mapState({
      leftmenu: state => state.leftmenu,
    }),
    methods: {
      changeActiveRouter: function (router) {
        this.$store.commit('leftmenu/activeRouterChange', router);
      },
      changeCurrentInstance: function (router) {
        this.$store.commit('leftmenu/activeRouterChange', router);
        this.$store.commit('leftmenu/selectInstance', router.instance);
      },
      inSubs: function (item) {
        let idx = item.subs.findIndex((el) => {
          if (el.router === this.activeRouter) {
            return true;
          }
          return false;
        });
        if (idx === -1)
          return false;
        else
          return true;
      },
      isCurrent: function (item) {
        return this.leftmenu.currentInstance === item.name;
      }
    },
  }

</script>

<style scoped>

</style>
